var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSecureIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 8.36364L8.75 6.43478L12.5 4L16.25 6.43478L20 8.36364V9.21784C20 14.0264 17.0083 18.3274 12.5 20C7.99171 18.3274 5 14.0264 5 9.21784V8.36364ZM9.50338 7.73407L12.5 5.78844L15.4966 7.73407L18.4998 9.27879C18.4758 13.2473 16.1092 16.8093 12.5 18.3833C8.89081 16.8093 6.52419 13.2473 6.50018 9.27879L9.50338 7.73407ZM9.26141 12.0887L11.691 14.5175L16.0153 10.1907L14.9544 9.13033L11.6905 12.396L10.3219 11.0278L9.26141 12.0887Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecureIcon);
export default __webpack_public_path__ + "static/media/secure-icon.e046b299d1557d339ff918d49d09bba2.svg";
export { ForwardRef as ReactComponent };